module.exports = __webpack_public_path__ + "img/icon_line.312c61fc.svg";